import { useMemo, useState } from "react";
import { SettingsContext } from ".";

interface Props {
  children: React.ReactNode;
}

export const SettingsProvider = ({ children }: Props) => {
  const [showBaseModal, setShowBaseModal] = useState(false);
  const [showResolutionsModal, setShowResolutionsModal] = useState(false);
  const [showPlaybackRateModal, setShowPlaybackRateModal] = useState(false);

  const value = useMemo(
    () => ({
      showBaseModal,
      setShowBaseModal,
      showResolutionsModal,
      showPlaybackRateModal,
      setShowResolutionsModal,
      setShowPlaybackRateModal,
    }),
    [showBaseModal, showPlaybackRateModal, showResolutionsModal]
  );

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
